module.exports = __webpack_public_path__ + "img/img_1.cd0f3253.jpeg";